import { render, staticRenderFns } from "./VueEditor.vue?vue&type=template&id=50f89ea4"
import script from "./VueEditor.vue?vue&type=script&lang=js"
export * from "./VueEditor.vue?vue&type=script&lang=js"
import style0 from "./VueEditor.vue?vue&type=style&index=0&id=50f89ea4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports